export enum QuestionnaireType {
  CHECK_IN = 'checkIn',
  HOLISTIC = 'holistic',
  CORE_PILLAR = 'corePillar',
  SPECIALISED = 'specialised',
}
